export default __webpack_public_path__ + "static/small-image-yangol-2-ee4ce275fb9eeaa1d9f98aa298795e44.png";